import { Alert, AlertTitle, Button, DialogContent, Grid } from "@mui/material";
import { CustomMuiButton } from "@unit/styles";
import { useRouter } from "next/router";
import React from "react";

import { accountInfoPath } from "@/global-state/influencer-app-path";

const AccountInfoSettingPane: React.FC = () => {
  const router = useRouter();

  return (
    <DialogContent>
      <Grid item xs={12} pb={2}>
        <Alert severity="warning">
          <AlertTitle>
            <strong>アカウント情報を設定してください</strong>
          </AlertTitle>
          ユニットをご利用いただきありがとうございます。
          <br />
          <strong>
            チケットに応募される前に、
            <br />
            マイページにてアカウント基本情報の設定をお願いします。
          </strong>
          <br />
          情報を入力することで採用されやすくなります。
        </Alert>
      </Grid>
      <Grid item xs={12}>
        <Button
          css={CustomMuiButton}
          type="submit"
          fullWidth
          variant="contained"
          size={"large"}
          onClick={() => router.push(accountInfoPath)}
        >
          アカウント情報設定ページへ
        </Button>
      </Grid>
    </DialogContent>
  );
};
export default React.memo(AccountInfoSettingPane);
